import { useCallback, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Br, Us } from 'react-flags-select'
import { useUser } from "store/models";
import useClickOutside from "../../../utils/useClickOutside";
import Icon from "components/Icon";

function openUserArea(){
  let currentTarget = document.getElementById("header-user-area");
  if(currentTarget){
    if(currentTarget.classList.contains("header-user-area-opened")){
      currentTarget.classList.remove("header-user-area-opened");
    } else {
      currentTarget.classList.add("header-user-area-opened");
    }
  }
}

export default function UserArea(){
  const user = useUser();
  const { t, i18n } = useTranslation()
  const history = useHistory();
  const ref = useRef(null);
  const closeWindow = useCallback(()=>{
    let currentTarget = document.getElementById("header-user-area");
    if(currentTarget){
      if(currentTarget.classList.contains("header-user-area-opened")){
        currentTarget.classList.remove("header-user-area-opened");
      }
    }
  },[]);
  useClickOutside(ref, closeWindow);
  const [ colorUser ] = useState(user.color)
  
  const [ l ] = useState([
    {name:"pt-BR",element:Br},
    {name:"en-US",element:Us},
  ]);
  const [ l2 ] = useState([
    {name:"light",element:()=>(<Icon name="sun"/>)},
    {name:"dark",element:()=>(<Icon name="moon"/>)}
  ]);

  const styleUserImage = useCallback(()=>{
    if(user.image_profile){
      return {backgroundImage: `url("${user.image_profile}")`}
    } else {
      return {background: colorUser.hex}
    }
  },[colorUser,user]);

  function _SetTheme(theme:string){
    user.setTheme(user.id,theme);
  }

  function _SetLanguage(language:string) {
    user.setLanguage(user.id,language)
    i18n.changeLanguage(language)
  }

  useLayoutEffect(()=>{
    let tbody = document.getElementById("header-user-area-free-tbody");
    let huser = document.getElementById("header-user-area");
    if(tbody && huser){
      let trs = tbody.getElementsByTagName("tr");
      if(trs){
        huser.style.maxHeight = `${210 + (41*trs.length)}px`;
      }
    }
  },[]);

  function renderTbody(){
    const list = [
      {
        title: t('title:language'),
        class: "list-expand",
        btn:(
          <div className="list-options">
            {l.map((item,key)=>{
              let Element = item.element;
              let l = "pt-BR";
              if(user.language){
                l = user.language;
              }
              return (
                <span key={key} className={l === item.name?"selected":""}
                  onClick={()=>{
                    _SetLanguage(item.name)
                  }}
                ><Element/></span>
              );
            })}
          </div>
        ) 
      },
      {
        title: 'theme',
        class: "list-expand",
        btn:(
          <div className="list-options">
            {l2.map((item,key)=>{
              let Element = item.element;
              let theme = "light";
              if(user.theme){
                theme = user.theme;
              }
              return (
                <span key={key} className={theme === item.name?"selected":""}
                  onClick={()=>{
                    _SetTheme(item.name)
                  }}
                ><Element/></span>
              );
            })}
          </div>
        ) 
      }
    ];
    return (
      <div id="header-user-area-free-body">
        {list.map((item, key)=>{
          return <div key={key} className={"header-user-area-free-item "+item.class}>
            <div className="header-user-area-free-body-title">{t('options:'+item.title)}</div>
            <div className="header-user-area-free-body-option">{item.btn}</div>
          </div>
        })}
      </div>
    );
  }

  return (
    <div id="header-user-area" ref={ref}>
      <div id="header-user-area-click" onClick={openUserArea}></div>
      <div id="header-user-area-content">
        <div id="header-user-area-image" style={styleUserImage()}>
          {user.image_profile?(""):(
            <div id="header-user-area-image-notimage">{user.firstname.substring(0,1).toUpperCase()}</div>
          )}
        </div>
        <div id="header-user-area-info">
          <div id="header-user-area-name">{`${user.firstname} ${user.lastname}`}</div>
          <div id="header-user-area-profile">{user.profile.name}</div>
        </div>
      </div>
      <div id="header-user-area-more">
        <div id="header-user-area-free">
          {renderTbody()}
        </div>
        <div id="header-user-area-more-btn">
          <div className="header-user-area-more-btn-item">
            <Icon name="bell"/>
          </div>
          <div className="header-user-area-more-btn-item" onClick={()=>{
            closeWindow();
            history.push(`/account`);
          }}>
            <Icon name="cog"/>
          </div>
          <div className="header-user-area-more-btn-item" onClick={()=>{
            closeWindow();
            let load = document.getElementById('load-root');
            if(load) {
              load.style.display = "";
              setTimeout(() =>{
                if(load)
                load.classList.remove("removing");
              },1);
              setTimeout(() =>{
                user.logout();
                window.location.reload();
              },1500);
            }
          }}>
            <Icon name="sign-out-alt"/>
          </div>
        </div>
      </div>
      <div id="header-user-area-icon">
        <Icon name="angle-down"/>
      </div>
      <div id="header-user-area-icon-close">
        <Icon name="times"/>
      </div>
    </div>
  );
}